var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-tooltip',{attrs:{"options":Object.assign({}, {permanent: false, 
    interactive: false,
    className: 'leaflet-custom-tooltip',
    offset: _vm.offset},
    _vm.options)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }